let _hexToRGB = (h, bypassLinear) => {
	let r = 0, g = 0, b = 0;

	// 3 digits
	if (h.length == 4) {
		r = "0x" + h[1] + h[1];
		g = "0x" + h[2] + h[2];
		b = "0x" + h[3] + h[3];

		// 6 digits
	} else if (h.length == 7) {
		r = "0x" + h[1] + h[2];
		g = "0x" + h[3] + h[4];
		b = "0x" + h[5] + h[6];
	}
	
	if (bypassLinear) {
  		var rgbArray = [
            (r / 255), 
            (g / 255), 
            (b / 255)
        ];
    } else {
  		var rgbArray = [
            _srgbToLinear(r / 255), 
            _srgbToLinear(g / 255), 
            _srgbToLinear(b / 255)
        ];
    }

	return rgbArray
}

let _srgbToLinear = (c) => {
    var v = 0.0;
    if ( c < 0.04045 ) {
        if ( c >= 0.0 )
            v = c * ( 1.0 / 12.92 );
    } else {
        v = Math.pow( ( c + 0.055 ) * ( 1.0 / 1.055 ), 2.4 );
    }
    return v;
};

let _linearToSrgb = ( c ) => {
    var v = 0.0;
    if ( c < 0.0031308 ) {
        if ( c > 0.0 )
            v = c * 12.92;
    } else {
        v = 1.055 * Math.pow( c, 1.0 / 2.4 ) - 0.055;
    }
    return v;
};

let __GHDConfiguratorBaseMaterials = (uvScale) => {
	
	let baseMaterials = {};
	
	baseMaterials['dyed-mystique'] = {
		AOPBR: { enable: false },
		AlbedoPBR: { enable: false },
		AlphaMask: { enable: false },
		Anisotropy: { enable: false },
		BumpMap: { enable: false },
		CavityPBR: { enable: false },
		ClearCoat: { enable: false },
		ClearCoatNormalMap: { enable: false },
		ClearCoatRoughness: { enable: false },
		DiffuseColor: { enable: false },
		DiffuseIntensity: { 
			color: [ 1, 1, 1],
			enable: true,
			factor: 1
		},
		DiffusePBR: { 
			enable: true,
			factor: 1
		},
		Displacement: { enable: false },
		EmitColor: { enable: false },
		GlossinessPBR: { enable: false },
		Matcap: { enable: false },
		MetalnessPBR: {	enable: false },
		Opacity: { enable: false },
		RoughnessPBR: {	
			UVTransforms: {
				offset: [0, 0],
				rotation: 0,
				scale: [(25 * uvScale).toFixed(0), (25 * uvScale).toFixed(0)]
			},
			enable: true,
			factor: 0.75,
			texture: {
				internalFormat: "LUMINANCE",
				magFilter: "LINEAR",
				minFilter: "LINEAR_MIPMAP_LINEAR",
				texCoordUnit: 0,
				textureTarget: "TEXTURE_2D",
				uid: "",
				wrapS: "REPEAT",
				wrapT: "REPEAT"
			} 
		},
		Sheen: { enable: false },
		SheenRoughness: { enable: false },
		SpecularColor: { enable: false },
		SpecularF0:  { enable: false },
		SpecularHardness: {	
			enable: true,
			factor: 12.5 
		},
		SpecularPBR: {
			enable: true,
			factor: 1
		},
		SubsurfaceScattering: { enable: false },
		SubsurfaceTranslucency: { enable: false }
	};

	baseMaterials['dyed-mesh'] = {
		AOPBR: { enable: false },
		AlbedoPBR: { enable: false },
		AlphaMask: { enable: false },
		Anisotropy: { enable: false },
		BumpMap: { enable: false },
		CavityPBR: { enable: false },
		ClearCoat: { enable: false },
		ClearCoatNormalMap: { enable: false },
		ClearCoatRoughness: { enable: false },
		DiffuseColor: { enable: false },
		DiffuseIntensity: { 
			color: [ 1, 1, 1],
			enable: true,
			factor: 1
		},
		DiffusePBR: { 
			enable: true,
			factor: 1
		},
		Displacement: { enable: false },
		EmitColor: { enable: false },
		GlossinessPBR: { enable: false },
		Matcap: { enable: false },
		MetalnessPBR: {	enable: false },
		Opacity: { 
			UVTransforms: {
				offset: [0, 0],
				rotation: 0,
				scale: [(80 * uvScale).toFixed(0), (80 * uvScale).toFixed(0)]
			},
			enable: true,
			factor: 1,
			invert: false,
			ior: 1,
			refractionColor: [1, 1, 1],
			roughnessFactor: 0,
			texture: {
				internalFormat: "LUMINANCE",
				magFilter: "LINEAR",
				minFilter: "LINEAR_MIPMAP_LINEAR",
				texCoordUnit: 0,
				textureTarget: "TEXTURE_2D",
				uid: "",
				wrapS: "REPEAT",
				wrapT: "REPEAT"
			},
			thinLayer: false,
			type: "alphaBlend",
			useAlbedoTint: false,
			useMicrosurfaceTexture: true,
			useNormalOffset: true,
		},
		RoughnessPBR: {
			enable: true,
			factor: 0.65,
			texture: null
		},
		Sheen: { enable: false },
		SheenRoughness: { enable: false },
		SpecularColor: { enable: false },
		SpecularF0: { enable: false },
		SpecularHardness: {	
			enable: true,
			factor: 12.5 
		},
		SpecularPBR: {
			enable: true,
			factor: 1
		},
		SubsurfaceScattering: { enable: false },
		SubsurfaceTranslucency: { enable: false }
	};
	
	baseMaterials['dyed-diamond-mesh'] = {
		AOPBR: { enable: false },
		AlbedoPBR: { enable: false },
		AlphaMask: { enable: false },
		Anisotropy: { enable: false },
		BumpMap: { enable: false },
		CavityPBR: { enable: false },
		ClearCoat: { enable: false },
		ClearCoatNormalMap: { enable: false },
		ClearCoatRoughness: { enable: false },
		DiffuseColor: { enable: false },
		DiffuseIntensity: { 
			color: [ 1, 1, 1],
			enable: true,
			factor: 1
		},
		DiffusePBR: { 
			enable: true,
			factor: 1
		},
		Displacement: { enable: false },
		EmitColor: { enable: false },
		GlossinessPBR: { enable: false },
		Matcap: { enable: false },
		MetalnessPBR: {	enable: false },
		Opacity: { 
			UVTransforms: {
				offset: [0, 0],
				rotation: 0,
				scale: [(125 * uvScale).toFixed(0), (125 * uvScale).toFixed(0)]
			},
			enable: true,
			factor: 1,
			invert: false,
			ior: 1,
			refractionColor: [1, 1, 1],
			roughnessFactor: 0,
			texture: {
				internalFormat: "LUMINANCE",
				magFilter: "LINEAR",
				minFilter: "LINEAR_MIPMAP_LINEAR",
				texCoordUnit: 0,
				textureTarget: "TEXTURE_2D",
				uid: "",
				wrapS: "REPEAT",
				wrapT: "REPEAT"
			},
			thinLayer: false,
			type: "alphaBlend",
			useAlbedoTint: false,
			useMicrosurfaceTexture: true,
			useNormalOffset: true,
		},
		RoughnessPBR: {
			enable: true,
			factor: 0.65,
			texture: null
		},
		Sheen: { enable: false },
		SheenRoughness: { enable: false },
		SpecularColor: { enable: false },
		SpecularF0: { enable: false },
		SpecularHardness: {	
			enable: true,
			factor: 12.5 
		},
		SpecularPBR: {
			enable: true,
			factor: 1
		},
		SubsurfaceScattering: { enable: false },
		SubsurfaceTranslucency: { enable: false }
	};

	baseMaterials['dyed-fog-mesh'] = {
		AOPBR: { enable: false },
		AlbedoPBR: { enable: false },
		AlphaMask: { enable: false },
		Anisotropy: { enable: false },
		BumpMap: { enable: false },
		CavityPBR: { enable: false },
		ClearCoat: { enable: false },
		ClearCoatNormalMap: { enable: false },
		ClearCoatRoughness: { enable: false },
		DiffuseColor: { enable: false },
		DiffuseIntensity: { 
			color: [ 1, 1, 1],
			enable: true,
			factor: 1
		},
		DiffusePBR: { 
			enable: true,
			factor: 1
		},
		Displacement: { enable: false },
		EmitColor: { enable: false },
		GlossinessPBR: { enable: false },
		Matcap: { enable: false },
		MetalnessPBR: {	enable: false },
		Opacity: { 
			UVTransforms: {
				offset: [0, 0],
				rotation: 0,
				scale: [(80 * uvScale).toFixed(0), (80 * uvScale).toFixed(0)]
			},
			enable: true,
			factor: 1,
			invert: false,
			ior: 1,
			refractionColor: [1, 1, 1],
			roughnessFactor: 0,
			texture: {
				internalFormat: "LUMINANCE",
				magFilter: "LINEAR",
				minFilter: "LINEAR_MIPMAP_LINEAR",
				texCoordUnit: 0,
				textureTarget: "TEXTURE_2D",
				uid: "",
				wrapS: "REPEAT",
				wrapT: "REPEAT"
			},
			thinLayer: false,
			type: "alphaBlend",
			useAlbedoTint: false,
			useMicrosurfaceTexture: true,
			useNormalOffset: true,
		},
		RoughnessPBR: {
			enable: true,
			factor: 0.4,
			texture: null
		},
		Sheen: { enable: false },
		SheenRoughness: { enable: false },
		SpecularColor: { enable: false },
		SpecularF0: { enable: false },
		SpecularHardness: {	
			enable: true,
			factor: 12.5 
		},
		SpecularPBR: {
			enable: true,
			factor: 1
		},
		SubsurfaceScattering: { enable: false },
		SubsurfaceTranslucency: { enable: false }
	};

	baseMaterials['dyed-matt'] = {
		AOPBR: { enable: false },
		AlbedoPBR: { enable: false },
		AlphaMask: { enable: false },
		Anisotropy: { enable: false },
		BumpMap: { enable: false },
		CavityPBR: { enable: false },
		ClearCoat: { enable: false },
		ClearCoatNormalMap: { enable: false },
		ClearCoatRoughness: { enable: false },
		DiffuseColor: { enable: false },
		DiffuseIntensity: { enable: false },
		DiffusePBR: {
			enable: true,
			factor: 1
		},
		Displacement: { enable: false },
		EmitColor: { enable: false },
		GlossinessPBR: { enable: false },
		Matcap: { enable: false },
		MetalnessPBR: { enable: false },
		Opacity: { enable: false },
		RoughnessPBR: {
			enable: true,
			factor: 0.65,
			texture: null
		},
		Sheen: { enable: false },
		SheenRoughness: { enable: false },
		SpecularColor: { enable: false },
		SpecularF0: { enable: false },
		SpecularHardness: { enable: false },
		SpecularPBR: {
			enable: true,
			factor: 1
		},
		SubsurfaceScattering: { enable: false },
		SubsurfaceTranslucency: { enable: false }
	};

	baseMaterials['dyed-wetlook'] = {
		AOPBR: { enable: false },
		AlbedoPBR: { enable: false },
		AlphaMask: { enable: false },
		Anisotropy: { enable: false },
		BumpMap: { enable: false },
		CavityPBR: { enable: false },
		ClearCoat: { enable: false },
		ClearCoatNormalMap: { enable: false },
		ClearCoatRoughness: { enable: false },
		DiffuseColor: { enable: false },
		DiffuseIntensity: { enable: false },
		DiffusePBR: {
			enable: true,
			factor: 1
		},
		Displacement: { enable: false },
		EmitColor: { enable: false },
		GlossinessPBR: { enable: false },
		Matcap: { enable: false },
		MetalnessPBR: { enable: false },
		Opacity: { enable: false },
		RoughnessPBR: {
			enable: true,
			factor: 0.35,
			texture: null
		},
		Sheen: { enable: false },
		SheenRoughness: { enable: false },
		SpecularColor: { enable: false },
		SpecularF0: { enable: false },
		SpecularHardness: { enable: false },
		SpecularPBR: {
			enable: true,
			factor: 1
		},
		SubsurfaceScattering: { enable: false },
		SubsurfaceTranslucency: { enable: false }
	};

	baseMaterials['printed-matt'] = {
		AOPBR: { enable: false },
		AlbedoPBR: { enable: false },
		Anisotropy: { enable: false },
		BumpMap: { enable: false },
		CavityPBR: { enable: false },
		ClearCoat: { enable: false },
		ClearCoatNormalMap: { enable: false },
		ClearCoatRoughness: { enable: false },
		DiffuseColor: { enable: false },
		DiffuseIntensity: { enable: false },
		DiffusePBR: {
			enable: true,
			factor: 1,
			UVTransforms: {
				offset: [0, 0],
				rotation: 0,
				scale: [1, -1]
			},
			texture: {
				internalFormat: "RGB",
				magFilter: "LINEAR",
				minFilter: "LINEAR_MIPMAP_LINEAR",
				texCoordUnit: 0,
				textureTarget: "TEXTURE_2D",
				uid: "",
				wrapS: "REPEAT",
				wrapT: "REPEAT"
			}
		},
		Displacement: { enable: false },
		EmitColor: { enable: false },
		GlossinessPBR: { enable: false },
		Matcap: { enable: false },
		MetalnessPBR: { enable: false },
		Opacity: { enable: false },
		RoughnessPBR: {
			enable: true,
			factor: 0.65,
			texture: null
		},
		Sheen: { enable: false },
		SheenRoughness: { enable: false },
		SpecularColor: { enable: false },
		SpecularF0: { enable: false },
		SpecularHardness: { enable: false },
		SpecularPBR: {
			enable: true,
			factor: 1,
			color: [0, 0, 0]
		},
		SubsurfaceScattering: { enable: false },
		SubsurfaceTranslucency: { enable: false }
	};

	baseMaterials['printed-mesh'] = {
		AOPBR: { enable: false },
		AlbedoPBR: { enable: false },
		AlphaMask: { enable: false },
		Anisotropy: { enable: false },
		BumpMap: { enable: false },
		CavityPBR: { enable: false },
		ClearCoat: { enable: false },
		ClearCoatNormalMap: { enable: false },
		ClearCoatRoughness: { enable: false },
		DiffuseColor: { enable: false },
		DiffuseIntensity: { 
			color: [ 1, 1, 1],
			enable: true,
			factor: 1
		},
		DiffusePBR: {
			enable: true,
			factor: 1,
			UVTransforms: {
				offset: [0, 0],
				rotation: 0,
				scale: [1, -1]
			},
			texture: {
				internalFormat: "RGB",
				magFilter: "LINEAR",
				minFilter: "LINEAR_MIPMAP_LINEAR",
				texCoordUnit: 0,
				textureTarget: "TEXTURE_2D",
				uid: "",
				wrapS: "REPEAT",
				wrapT: "REPEAT"
			}
		},
		Displacement: { enable: false },
		EmitColor: { enable: false },
		GlossinessPBR: { enable: false },
		Matcap: { enable: false },
		MetalnessPBR: {	enable: false },
		Opacity: { 
			UVTransforms: {
				offset: [0, 0],
				rotation: 0,
				scale: [(80 * uvScale).toFixed(0), (80 * uvScale).toFixed(0)]
			},
			enable: true,
			factor: 1,
			invert: false,
			ior: 1,
			refractionColor: [1, 1, 1],
			roughnessFactor: 0,
			texture: {
				internalFormat: "LUMINANCE",
				magFilter: "LINEAR",
				minFilter: "LINEAR_MIPMAP_LINEAR",
				texCoordUnit: 0,
				textureTarget: "TEXTURE_2D",
				uid: "",
				wrapS: "REPEAT",
				wrapT: "REPEAT"
			},
			thinLayer: false,
			type: "alphaBlend",
			useAlbedoTint: false,
			useMicrosurfaceTexture: true,
			useNormalOffset: true,
		},
		RoughnessPBR: {
			enable: true,
			factor: 0.65,
			texture: null
		},
		Sheen: { enable: false },
		SheenRoughness: { enable: false },
		SpecularColor: { enable: false },
		SpecularF0: { enable: false },
		SpecularHardness: {	
			enable: true,
			factor: 12.5 
		},
		SpecularPBR: {
			enable: true,
			factor: 1,
			color: [0, 0, 0]
		},
		SubsurfaceScattering: { enable: false },
		SubsurfaceTranslucency: { enable: false }
	};

	baseMaterials['crystal'] = {
		AOPBR: { enable: false },
		AlbedoPBR: { enable: false },
		AlphaMask: { enable: false },
		Anisotropy: { enable: false },
		BumpMap: { enable: false },
		CavityPBR: { enable: false },
		ClearCoat: { enable: false },
		ClearCoatNormalMap: { enable: false },
		ClearCoatRoughness: { enable: false },
		DiffuseColor: { enable: false },
		DiffuseIntensity: { enable: false },
		DiffusePBR: {
			enable: true,
			factor: 1
		},
		Displacement: { enable: false },
		EmitColor: { enable: false },
		GlossinessPBR: { enable: false },
		Matcap: { enable: false },
		MetalnessPBR: {	enable: false },
		Opacity: {	enable: false },
		RoughnessPBR: {
			enable: true,
			factor: 0.3,
			texture: null
		},
		Sheen: { 
			UVTransforms: {
				offset: [0, 0],
				rotation: 0,
				scale: [(15 * uvScale).toFixed(0), (15 * uvScale).toFixed(0)]
			},
			enable: true,
			factor: 1,
			texture: {
				internalFormat: "RGB",
				magFilter: "LINEAR",
				minFilter: "LINEAR_MIPMAP_LINEAR",
				texCoordUnit: 0,
				textureTarget: "TEXTURE_2D",
				uid: "",
				wrapS: "MIRROR",
				wrapT: "MIRROR"
			}
		},
		SheenRoughness: { 
			enable: true,
			factor: 0.3,
		},
		SpecularColor: { enable: false },
		SpecularF0: { enable: false },
		SpecularHardness: { enable: false },
		SpecularPBR: {
			enable: true,
			factor: 1
		},
		SubsurfaceScattering: { enable: false },
		SubsurfaceTranslucency: { enable: false }
	};

	baseMaterials['lining'] = {
		AOPBR: { enable: false },
		AlbedoPBR: { enable: false },
		AlphaMask: { enable: false },
		Anisotropy: { enable: false },
		BumpMap: { enable: false },
		CavityPBR: { enable: false },
		ClearCoat: { enable: false },
		ClearCoatNormalMap: { enable: false },
		ClearCoatRoughness: { enable: false },
		DiffuseColor: { enable: false },
		DiffuseIntensity: { enable: false },
		DiffusePBR: {
			enable: true,
			factor: 1
		},
		Displacement: { enable: false },
		EmitColor: { enable: false },
		GlossinessPBR: { enable: false },
		Matcap: { enable: false },
		MetalnessPBR: { enable: false },
		Opacity: { 
			enable: true,
			factor: 1,
			invert: false,
			ior: 1,
			refractionColor: [1, 1, 1],
			roughnessFactor: 0,
			texture: null,
			thinLayer: false,
			type: "alphaBlend",
			useAlbedoTint: false,
			useMicrosurfaceTexture: true,
			useNormalOffset: true,
		},
		RoughnessPBR: {
			enable: true,
			factor: 0.65,
			texture: null
		},
		Sheen: { enable: false },
		SheenRoughness: { enable: false },
		SpecularColor: { enable: false },
		SpecularF0: { enable: false },
		SpecularHardness: { enable: false },
		SpecularPBR: {
			enable: true,
			factor: 1
		},
		SubsurfaceScattering: { enable: false },
		SubsurfaceTranslucency: { enable: false }
	};
  
	return baseMaterials;
};


let __GHDConfiguratorCustomMaterials = () => {
	let customMaterials = {};
	
	customMaterials['printed-matt-aqua'] = {
		hexCode: "#33B2E1",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};
	
	customMaterials['printed-matt-belize'] = {
		hexCode: "#1F2643",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-matt-black'] = {
		hexCode: "#000000",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-matt-blush'] = {
		hexCode: "#C17D7D",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-matt-bubblegum'] = {
		hexCode: "#F8679D",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-matt-coral'] = {
		hexCode: "#FA4848",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-matt-crystal'] = {
		hexCode: "#95D9E3",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-matt-dark-plum'] = {
		hexCode: "#46012F",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-matt-deep-sea'] = {
		hexCode: "#021722",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-matt-deep-teal'] = {
		hexCode: "#025652",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-matt-energize'] = {
		hexCode: "#ea5791",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-matt-emerald-green'] = {
		hexCode: "#073605",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-matt-fuchsia'] = {
		hexCode: "#DC0141",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-matt-hawaiian-blue'] = {
		hexCode: "#75D9E8",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-matt-hot-pink'] = {
		hexCode: "#FC1D70",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};
	
	customMaterials['printed-matt-lagoon'] = {
		hexCode: "#0b5058",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-matt-lavendar'] = {
		hexCode: "#B09EDC",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-matt-leaf-green'] = {
		hexCode: "#47890A",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-matt-light-grey'] = {
		hexCode: "#949090",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-matt-light-peach'] = {
		hexCode: "#FA887A",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-matt-light-pink'] = {
		hexCode: "#F893B6",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-matt-lilac'] = {
		hexCode: "#A53B82",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-matt-lime-green'] = {
		hexCode: "#7DB007",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-matt-maroon'] = {
		hexCode: "#610015",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-matt-mint'] = {
		hexCode: "#98E1C8",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-matt-navy'] = {
		hexCode: "#000A31",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-matt-nectarine'] = {
		hexCode: "#F40135",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-matt-neon-coral'] = {
		hexCode: "#FD6273",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-matt-ocean'] = {
		hexCode: "#0D617B",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-matt-opulent'] = {
		hexCode: "#A7093F",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-matt-orange'] = {
		hexCode: "#FD5100",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-matt-pale-grey'] = {
		hexCode: "#C9C9C9",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

  	customMaterials['printed-matt-periwinkle'] = {
		hexCode: "#b3c0df",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};
  
	customMaterials['printed-matt-pear'] = {
		hexCode: "#CBDA2D",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-matt-plum'] = {
		hexCode: "#5A003A",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};
	
	customMaterials['printed-matt-pony'] = {
		hexCode: "#E2A8FA",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-matt-purple'] = {
		hexCode: "#4E1E7B",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-matt-red'] = {
		hexCode: "#D10006",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-matt-reflexion'] = {
		hexCode: "#C06BB3",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-matt-reflection'] = {
		hexCode: "#C06BB3",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};


	customMaterials['printed-matt-rose-gold'] = {
		hexCode: "#A25B6E",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-matt-royal'] = {
		hexCode: "#002E95",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-matt-sky-blue'] = {
		hexCode: "#48ACE6",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-matt-slate-grey'] = {
		hexCode: "#444343",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-matt-spring-green'] = {
		hexCode: "#70DCBC",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-matt-teal'] = {
		hexCode: "#068C8C",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-matt-ultra-marine'] = {
		hexCode: "#0D7EB3",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-matt-violet'] = {
		hexCode: "#9064BA",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-matt-white'] = {
		hexCode: "#FFFFFF",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-matt-yellow'] = {
		hexCode: "#F3DE1F",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-matt-light-nude'] = {
		hexCode: "#E8A27C",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-matt-mid-nude'] = {
		hexCode: "#C37A54",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-matt-deep-nude'] = {
		hexCode: "#8D451F",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};


	// Matt Mesh Only

	customMaterials['printed-mesh-aqua'] = {
		hexCode: "#33B2E1",
		pbrSpecification: {
			baseMaterial: 'printed-mesh',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};
	
	customMaterials['printed-mesh-belize'] = {
		hexCode: "#1F2643",
		pbrSpecification: {
			baseMaterial: 'printed-mesh',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-mesh-black'] = {
		hexCode: "#000000",
		pbrSpecification: {
			baseMaterial: 'printed-mesh',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-mesh-blush'] = {
		hexCode: "#C17D7D",
		pbrSpecification: {
			baseMaterial: 'printed-mesh',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-mesh-bubblegum'] = {
		hexCode: "#F8679D",
		pbrSpecification: {
			baseMaterial: 'printed-mesh',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-mesh-coral'] = {
		hexCode: "#FA4848",
		pbrSpecification: {
			baseMaterial: 'printed-mesh',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};


	customMaterials['printed-mesh-crystal'] = {
		hexCode: "#95D9E3",
		pbrSpecification: {
			baseMaterial: 'printed-mesh',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-mesh-dark-plum'] = {
		hexCode: "#46012F",
		pbrSpecification: {
			baseMaterial: 'printed-mesh',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-mesh-deep-sea'] = {
		hexCode: "#021722",
		pbrSpecification: {
			baseMaterial: 'printed-mesh',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-mesh-deep-teal'] = {
		hexCode: "#025652",
		pbrSpecification: {
			baseMaterial: 'printed-mesh',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-mesh-energize'] = {
		hexCode: "#ea5791",
		pbrSpecification: {
			baseMaterial: 'printed-mesh',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-mesh-emerald-green'] = {
		hexCode: "#073605",
		pbrSpecification: {
			baseMaterial: 'printed-mesh',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-mesh-fuchsia'] = {
		hexCode: "#DC0141",
		pbrSpecification: {
			baseMaterial: 'printed-mesh',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-mesh-hawaiian-blue'] = {
		hexCode: "#75D9E8",
		pbrSpecification: {
			baseMaterial: 'printed-mesh',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-mesh-hot-pink'] = {
		hexCode: "#FC1D70",
		pbrSpecification: {
			baseMaterial: 'printed-mesh',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};
	
	customMaterials['printed-mesh-lagoon'] = {
		hexCode: "#0A4852",
		pbrSpecification: {
			baseMaterial: 'printed-mesh',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-mesh-lavendar'] = {
		hexCode: "#B09EDC",
		pbrSpecification: {
			baseMaterial: 'printed-mesh',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-mesh-leaf-green'] = {
		hexCode: "#47890A",
		pbrSpecification: {
			baseMaterial: 'printed-mesh',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-mesh-light-grey'] = {
		hexCode: "#949090",
		pbrSpecification: {
			baseMaterial: 'printed-mesh',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-mesh-light-peach'] = {
		hexCode: "#FA887A",
		pbrSpecification: {
			baseMaterial: 'printed-mesh',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-mesh-light-pink'] = {
		hexCode: "#F893B6",
		pbrSpecification: {
			baseMaterial: 'printed-mesh',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-mesh-lilac'] = {
		hexCode: "#A53B82",
		pbrSpecification: {
			baseMaterial: 'printed-mesh',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-mesh-lime-green'] = {
		hexCode: "#7DB007",
		pbrSpecification: {
			baseMaterial: 'printed-mesh',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-mesh-maroon'] = {
		hexCode: "#610015",
		pbrSpecification: {
			baseMaterial: 'printed-mesh',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-mesh-mint'] = {
		hexCode: "#98E1C8",
		pbrSpecification: {
			baseMaterial: 'printed-mesh',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-mesh-navy'] = {
		hexCode: "#000A31",
		pbrSpecification: {
			baseMaterial: 'printed-mesh',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-mesh-nectarine'] = {
		hexCode: "#F40135",
		pbrSpecification: {
			baseMaterial: 'printed-mesh',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-mesh-neon-coral'] = {
		hexCode: "#FD6273",
		pbrSpecification: {
			baseMaterial: 'printed-mesh',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-mesh-ocean'] = {
		hexCode: "#0D617B",
		pbrSpecification: {
			baseMaterial: 'printed-mesh',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-mesh-opulent'] = {
		hexCode: "#A7093F",
		pbrSpecification: {
			baseMaterial: 'printed-mesh',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-mesh-orange'] = {
		hexCode: "#FD5100",
		pbrSpecification: {
			baseMaterial: 'printed-mesh',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-mesh-pale-grey'] = {
		hexCode: "#C9C9C9",
		pbrSpecification: {
			baseMaterial: 'printed-mesh',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

  	customMaterials['printed-mesh-periwinkle'] = {
		hexCode: "#b3c0df",
		pbrSpecification: {
			baseMaterial: 'printed-matt',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};
  
	customMaterials['printed-mesh-pear'] = {
		hexCode: "#CBDA2D",
		pbrSpecification: {
			baseMaterial: 'printed-mesh',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-mesh-plum'] = {
		hexCode: "#5A003A",
		pbrSpecification: {
			baseMaterial: 'printed-mesh',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};
	
	customMaterials['printed-mesh-pony'] = {
		hexCode: "#E2A8FA",
		pbrSpecification: {
			baseMaterial: 'printed-mesh',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-mesh-purple'] = {
		hexCode: "#4E1E7B",
		pbrSpecification: {
			baseMaterial: 'printed-mesh',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-mesh-red'] = {
		hexCode: "#D10006",
		pbrSpecification: {
			baseMaterial: 'printed-mesh',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-mesh-reflexion'] = {
		hexCode: "#C06BB3",
		pbrSpecification: {
			baseMaterial: 'printed-mesh',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-mesh-reflection'] = {
		hexCode: "#C06BB3",
		pbrSpecification: {
			baseMaterial: 'printed-mesh',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};


	customMaterials['printed-mesh-rose-gold'] = {
		hexCode: "#A25B6E",
		pbrSpecification: {
			baseMaterial: 'printed-mesh',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-mesh-royal'] = {
		hexCode: "#002E95",
		pbrSpecification: {
			baseMaterial: 'printed-mesh',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-mesh-sky-blue'] = {
		hexCode: "#48ACE6",
		pbrSpecification: {
			baseMaterial: 'printed-mesh',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-mesh-slate-grey'] = {
		hexCode: "#444343",
		pbrSpecification: {
			baseMaterial: 'printed-mesh',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-mesh-spring-green'] = {
		hexCode: "#70DCBC",
		pbrSpecification: {
			baseMaterial: 'printed-mesh',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-mesh-teal'] = {
		hexCode: "#068C8C",
		pbrSpecification: {
			baseMaterial: 'printed-mesh',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-mesh-ultra-marine'] = {
		hexCode: "#0D7EB3",
		pbrSpecification: {
			baseMaterial: 'printed-mesh',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-mesh-violet'] = {
		hexCode: "#9064BA",
		pbrSpecification: {
			baseMaterial: 'printed-mesh',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-mesh-white'] = {
		hexCode: "#FFFFFF",
		pbrSpecification: {
			baseMaterial: 'printed-mesh',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-mesh-yellow'] = {
		hexCode: "#F3DE1F",
		pbrSpecification: {
			baseMaterial: 'printed-mesh',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-mesh-light-nude'] = {
		hexCode: "#E8A27C",
		pbrSpecification: {
			baseMaterial: 'printed-mesh',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-mesh-mid-nude'] = {
		hexCode: "#C37A54",
		pbrSpecification: {
			baseMaterial: 'printed-mesh',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['printed-mesh-deep-nude'] = {
		hexCode: "#8D451F",
		pbrSpecification: {
			baseMaterial: 'printed-mesh',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	// Mystique Dyed Only

	customMaterials['dyed-mystique-amazon'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mystique',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#007E7E')
				},
				SpecularPBR: {
					color: _hexToRGB('#008E84')
				}
			}
		}
	};
	
	customMaterials['dyed-mystique-aqua'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mystique',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#05859E')
				},
				SpecularPBR: {
					color: _hexToRGB('#0E4D68')
				}
			}
		}
	};

	customMaterials['dyed-mystique-baby-blue'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mystique',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#60869F')
				},
				SpecularPBR: {
					color: _hexToRGB('#D1D1D1')
				}
			}
		}
	};

	customMaterials['dyed-mystique-black'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mystique',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#000000')
				},
				SpecularPBR: {
					color: _hexToRGB('#3D3939')
				}
			}
		}
	};

	customMaterials['dyed-mystique-black-matt'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mystique',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#000000')
				},
				SpecularPBR: {
					color: _hexToRGB('#191919')
				}
			}
		}
	};

	customMaterials['dyed-mystique-boysenberry'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mystique',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#BE2285')
				},
				SpecularPBR: {
					color: _hexToRGB('#7A687B')
				}
			}
		}
	};

	customMaterials['dyed-mystique-bubblegum'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mystique',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#FC56A9')
				},
				SpecularPBR: {
					color: _hexToRGB('#F5E2E6')
				}
			}
		}
	};

	customMaterials['dyed-mystique-deep-sea'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mystique',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#08324D')
				},
				SpecularPBR: {
					color: _hexToRGB('#374045')
				}
			}
		}
	};

	customMaterials['dyed-mystique-emerald-green'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mystique',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#18563A')
				},
				SpecularPBR: {
					color: _hexToRGB('#127347')
				}
			}
		}
	};

	customMaterials['dyed-mystique-fuchsia'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mystique',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#CA0233')
				},
				SpecularPBR: {
					color: _hexToRGB('#D83894')
				}
			}
		}
	};

	customMaterials['dyed-mystique-gold'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mystique',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#BFAA6B')
				},
				SpecularPBR: {
					color: _hexToRGB('#C4B36B')
				}
			}
		}
	};

	customMaterials['dyed-mystique-gold-green'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mystique',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#7EDE00')
				},
				SpecularPBR: {
					color: _hexToRGB('#C4E706')
				}
			}
		}
	};

	customMaterials['dyed-mystique-grape'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mystique',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#5F00B0')
				},
				SpecularPBR: {
					color: _hexToRGB('#0086A5')
				}
			}
		}
	};

	customMaterials['dyed-mystique-gunmetal'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mystique',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#4C4D4D')
				},
				SpecularPBR: {
					color: _hexToRGB('#424439')
				}
			}
		}
	};

	customMaterials['dyed-mystique-hawaiian-blue'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mystique',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#5f9db0')
				},
				SpecularPBR: {
					color: _hexToRGB('#5f9db0')
				}
			}
		}
	};

	customMaterials['dyed-mystique-hawaiian-mint'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mystique',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#3ACCD9')
				},
				SpecularPBR: {
					color: _hexToRGB('#A19E4B')
				}
			}
		}
	};

	customMaterials['dyed-mystique-hot-pink'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mystique',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#F809A8')
				},
				SpecularPBR: {
					color: _hexToRGB('#787878')
				}
			}
		}
	};

	customMaterials['dyed-mystique-jade'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mystique',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#00332B')
				},
				SpecularPBR: {
					color: _hexToRGB('#009AA5')
				}
			}
		}
	};	

	customMaterials['dyed-mystique-lavender'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mystique',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#9475E6')
				},
				SpecularPBR: {
					color: _hexToRGB('#9666A4')
				}
			}
		}
	};	

	customMaterials['dyed-mystique-lime-green'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mystique',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#7EDE00')
				},
				SpecularPBR: {
					color: _hexToRGB('#777777')
				}
			}
		}
	};

	customMaterials['dyed-mystique-maroon'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mystique',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#630322')
				},
				SpecularPBR: {
					color: _hexToRGB('#3D0001')
				}
			}
		}
	};

	customMaterials['dyed-mystique-navy'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mystique',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#010D1C')
				},
				SpecularPBR: {
					color: _hexToRGB('#0B162F')
				}
			}
		}
	};

	customMaterials['dyed-mystique-ocean'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mystique',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#1A384D')
				},
				SpecularPBR: {
					color: _hexToRGB('#539AAE')
				}
			}
		}
	};	

	customMaterials['dyed-mystique-orange-gold'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mystique',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#F94900')
				},
				SpecularPBR: {
					color: _hexToRGB('#EC5A0E')
				}
			}
		}
	};

	customMaterials['dyed-mystique-pink-fluro-orange'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mystique',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#B65328')
				},
				SpecularPBR: {
					color: _hexToRGB('#D763B8')
				}
			}
		}
	};

	customMaterials['dyed-mystique-plum'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mystique',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#2E2371')
				},
				SpecularPBR: {
					color: _hexToRGB('#CC4FF2')
				}
			}
		}
	};

	customMaterials['dyed-mystique-purple'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mystique',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#380F61')
				},
				SpecularPBR: {
					color: _hexToRGB('#5D23A0')
				}
			}
		}
	};

	customMaterials['dyed-mystique-red'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mystique',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#A20606')
				},
				SpecularPBR: {
					color: _hexToRGB('#B50707')
				}
			}
		}
	};

	customMaterials['dyed-mystique-rose-gold'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mystique',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#865B65')
				},
				SpecularPBR: {
					color: _hexToRGB('#865B65')
				}
			}
		}
	};

	customMaterials['dyed-mystique-royal'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mystique',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#004A96')
				},
				SpecularPBR: {
					color: _hexToRGB('#205C90')
				}
			}
		}
	};

	customMaterials['dyed-mystique-royal-navy'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mystique',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#113162')
				},
				SpecularPBR: {
					color: _hexToRGB('#2364A5')
				}
			}
		}
	};

	customMaterials['dyed-mystique-seaweed'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mystique',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#0146A8')
				},
				SpecularPBR: {
					color: _hexToRGB('#167900')
				}
			}
		}
	};

	customMaterials['dyed-mystique-shocking-pink'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mystique',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#FF3EB4')
				},
				SpecularPBR: {
					color: _hexToRGB('#B6B6B6')
				}
			}
		}
	};

	customMaterials['dyed-mystique-silver-white'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mystique',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#D0CDCD')
				},
				SpecularPBR: {
					color: _hexToRGB('#E9E9E9')
				}
			}
		}
	};

	customMaterials['dyed-mystique-white-pearl'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mystique',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#F5EFEF')
				},
				SpecularPBR: {
					color: _hexToRGB('#D5C9C9')
				}
			}
		}
	};

	customMaterials['dyed-mystique-yellow'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mystique',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#FFB000')
				},
				SpecularPBR: {
					color: _hexToRGB('#FFA200')
				}
			}
		}
	};

	// Matt Dyed

	customMaterials['dyed-matt-acid-green'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-matt',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#7EDE00')
				},
				SpecularPBR: {
					color: _hexToRGB('#7EDE00')
				}
			}
		}
	};

	customMaterials['dyed-matt-aquamarine'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-matt',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#68cdd9')
				},
				SpecularPBR: {
					color: _hexToRGB('#0e5464')
				}
			}
		}
	};
	
	customMaterials['dyed-matt-belize'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-matt',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#222A49')
				},
				SpecularPBR: {
					color: _hexToRGB('#1D1C45')
				},
				RoughnessPBR: {
					factor: 0.85
				}
			}
		}
	};

	customMaterials['dyed-matt-black'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-matt',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#00030F')
				},
				SpecularPBR: {
					color: _hexToRGB('#161617')
				},
				RoughnessPBR: {
					factor: 0.5
				}
			}
		}
	};

	customMaterials['dyed-matt-bright-violet'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-matt',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#5f22b4')
				},
				SpecularPBR: {
					color: _hexToRGB('#5f22b4')
				}
			}
		}

	};

	customMaterials['dyed-matt-caribbean'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-matt',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#1BE1D6')
				},
				SpecularPBR: {
					color: _hexToRGB('#000000')
				}
			}
		}
	};

	customMaterials['dyed-matt-cloud'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-matt',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#939393')
				},
				SpecularPBR: {
					color: _hexToRGB('#939393')
				}
			}
		}
	};

	customMaterials['dyed-matt-crystal'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-matt',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#95D9E3')
				},
				SpecularPBR: {
					color: _hexToRGB('#3E7287')
				},
				RoughnessPBR: {
					factor: 1
				}
			}
		}
	};

	customMaterials['dyed-matt-dark-royal'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-matt',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#003ACB')
				},
				SpecularPBR: {
					color: _hexToRGB('#3F3F3F')
				}
			}
		}
	};

	customMaterials['dyed-matt-electric-blue'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-matt',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#00B3E3')
				},
				SpecularPBR: {
					color: _hexToRGB('#008197')
				}
			}
		}
	};

	customMaterials['dyed-matt-energize'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-matt',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#ea1887')
				},
				SpecularPBR: {
					color: _hexToRGB('#4d414d')
				}
			}
		}
	};

	customMaterials['dyed-matt-frozen'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-matt',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#86FFEF')
				},
				SpecularPBR: {
					color: _hexToRGB('#9D9D9D')
				}
			}
		}
	};

  	customMaterials['dyed-matt-forest-green'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-matt',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#074f3a')
				},
				SpecularPBR: {
					color: _hexToRGB('#2e4039')
				}
			}
		}
	};
  
	customMaterials['dyed-matt-hollywood'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-matt',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#efa0b5')
				},
				SpecularPBR: {
					color: _hexToRGB('#daa7c6')
				}
			}
		}
	};

	customMaterials['dyed-matt-illusion'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-matt',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#694547')
				},
				SpecularPBR: {
					color: _hexToRGB('#694547')
				}
			}
		}
	};

	customMaterials['dyed-matt-jade'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-matt',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#00645A')
				},
				SpecularPBR: {
					color: _hexToRGB('#00645A')
				}
			}
		}
	};
	
	customMaterials['dyed-matt-lagoon'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-matt',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#054e55')
				},
				SpecularPBR: {
					color: _hexToRGB('#147f89')
				},
				RoughnessPBR: {
					factor: 1
				}
			}
		}
	};

	customMaterials['dyed-matt-lavendar'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-matt',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#8244F4')
				},
				SpecularPBR: {
					color: _hexToRGB('#AAA1A1')
				},
				RoughnessPBR: {
					factor: 0.85
				}
			}
		}
	};

	customMaterials['dyed-matt-luxury'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-matt',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#14A9B1')
				},
				SpecularPBR: {
					color: _hexToRGB('#006A73')
				}
			}
		}
	};
	
	customMaterials['dyed-matt-malta'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-matt',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#47E6C0')
				},
				SpecularPBR: {
					color: _hexToRGB('#000000')
				},
				RoughnessPBR: {
					factor: 0.85
				}
			}
		}
	};

	customMaterials['dyed-matt-mandarin'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-matt',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#FA5D00')
				},
				SpecularPBR: {
					color: _hexToRGB('#FA5D00')
				}
			}
		}
	};

	customMaterials['dyed-matt-merlot'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-matt',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#600C17')
				},
				SpecularPBR: {
					color: _hexToRGB('#250912')
				}
			}
		}
	};

	customMaterials['dyed-matt-navy'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-matt',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#000A31')
				},
				SpecularPBR: {
					color: _hexToRGB('#0D0D0D')
				},
				RoughnessPBR: {
					factor: 1
				}
			}
		}
	};
	
	customMaterials['dyed-matt-neon-coral'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-matt',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#FF0606')
				},
				SpecularPBR: {
					color: _hexToRGB('#F173B6')
				},
				RoughnessPBR: {
					factor: 1
				}
			}
		}
	};

	customMaterials['dyed-matt-new-gold'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-matt',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#FC9300')
				},
				SpecularPBR: {
					color: _hexToRGB('#3F3C36')
				}
			}
		}
	};

	customMaterials['dyed-matt-new-royal'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-matt',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#5777E8')
				},
				SpecularPBR: {
					color: _hexToRGB('#3D58D1')
				}
			}
		}
	};

	customMaterials['dyed-matt-new-sunshine'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-matt',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#F9EE00')
				},
				SpecularPBR: {
					color: _hexToRGB('#C45959')
				},
				RoughnessPBR: {
					factor: 1
				}
			}
		}
	};

	customMaterials['dyed-matt-ocean'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-matt',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#136574')
				},
				SpecularPBR: {
					color: _hexToRGB('#051a44')
				}
			}
		}
	};

	customMaterials['dyed-matt-opulent'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-matt',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#7A0443')
				},
				SpecularPBR: {
					color: _hexToRGB('#4A0031')
				}
			}
		}
	};

	customMaterials['dyed-matt-pony'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-matt',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#E6B6F9')
				},
				SpecularPBR: {
					color: _hexToRGB('#505050')
				},
				RoughnessPBR: {
					factor: 1
				}
			}
		}
	};

	customMaterials['dyed-matt-reflexion'] = {
			pbrSpecification: {
			baseMaterial: 'dyed-matt',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#e870d3')
				},
				SpecularPBR: {
					color: _hexToRGB('#626262')
				}
			}
		}
	};

	customMaterials['dyed-matt-shocking-pink'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-matt',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#FF009C')
				},
				SpecularPBR: {
					color: _hexToRGB('#FF8CD2')
				}
			}
		}
	};

	customMaterials['dyed-matt-slate'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-matt',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#4C4D4D')
				},
				SpecularPBR: {
					color: _hexToRGB('#292A29')
				}
			}
		}
	};
	
	customMaterials['dyed-matt-sporting-red'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-matt',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#B20000')
				},
				SpecularPBR: {
					color: _hexToRGB('#4C4343')
				},
				RoughnessPBR: {
					factor: 1
				}
			}
		}
	};

	customMaterials['dyed-matt-spring-green'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-matt',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#70DCBC')
				},
				SpecularPBR: {
					color: _hexToRGB('#9D9D9D')
				},
				RoughnessPBR: {
					factor: 1
				}
			}
		}
	};

	customMaterials['dyed-matt-teal'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-matt',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#07746e')
				},
				SpecularPBR: {
					color: _hexToRGB('#0c8686')
				}
			}
		}
	};
  
	customMaterials['dyed-matt-thai'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-matt',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#CC028E')
				},
				SpecularPBR: {
					color: _hexToRGB('#555454')
				}
			}
		}
	};

	customMaterials['dyed-matt-ultra-marine'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-matt',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#189FE3')
				},
				SpecularPBR: {
					color: _hexToRGB('#014E90')
				}
			}
		}
	};
	
	customMaterials['dyed-matt-ultra-violet'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-matt',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#7D229B')
				},
				SpecularPBR: {
					color: _hexToRGB('#9138AA')
				},
				RoughnessPBR: {
					factor: 1
				}
			}
		}
	};

	customMaterials['dyed-matt-venetian-red'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-matt',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#DC0000')
				},
				SpecularPBR: {
					color: _hexToRGB('#950D00')
				}
			}
		}
	};

	customMaterials['dyed-matt-white'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-matt',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#FFFFFF')
				},
				SpecularPBR: {
					color: _hexToRGB('#222222')
				}
			}
		}
	};

	customMaterials['dyed-matt-wine'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-matt',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#4D0033')
				},
				SpecularPBR: {
					color: _hexToRGB('#1C1C1C')
				}
			}
		}
	};

	// Wet Look

	customMaterials['dyed-wetlook-black'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-wetlook',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#080707')
				},
				SpecularPBR: {
					color: _hexToRGB('#222222')
				}
			}
		}
	};

	customMaterials['dyed-wetlook-dark-royal'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-wetlook',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#014DAE')
				},
				SpecularPBR: {
					color: _hexToRGB('#444444')
				}
			}
		}
	};

	customMaterials['dyed-wetlook-energize'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-wetlook',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#F809A8')
				},
				SpecularPBR: {
					color: _hexToRGB('#444444')
				}
			}
		}
	};

	customMaterials['dyed-wetlook-graphite'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-wetlook',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#484242')
				},
				SpecularPBR: {
					color: _hexToRGB('#444444')
				}
			}
		}
	};

	customMaterials['dyed-wetlook-navy'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-wetlook',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#000A44')
				},
				SpecularPBR: {
					color: _hexToRGB('#444444')
				}
			}
		}
	};

	customMaterials['dyed-wetlook-ocean'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-wetlook',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#0e4f67')
				},
				SpecularPBR: {
					color: _hexToRGB('#112324')
				}
			}
		}
	};

	customMaterials['dyed-wetlook-red'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-wetlook',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#981C20')
				},
				SpecularPBR: {
					color: _hexToRGB('#4C3434')
				}
			}
		}
	};

	customMaterials['dyed-wetlook-wine'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-wetlook',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#4D0033')
				},
				SpecularPBR: {
					color: _hexToRGB('#33262F')
				}
			}
		}
	};

	//  Mesh

	customMaterials['dyed-mesh-amazon'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mesh',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#007E7E')
				},
				SpecularPBR: {
					color: _hexToRGB('#00B3A6')
				},
				Opacity: {
	                 factor: 1
				}
			}
		}
	};

	customMaterials['dyed-mesh-aqua'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mesh',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#00C4DB')
				},
				SpecularPBR: {
					color: _hexToRGB('#212121')
				},
				Opacity: {
	                 factor: 1
				}

			}
		}
	};

  	customMaterials['dyed-mesh-aqua-marine'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mesh',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#68cad9')
				},
				SpecularPBR: {
					color: _hexToRGB('#0e5464')
				},
				Opacity: {
	                 factor: 1
				}

			}
		}
	};

	customMaterials['dyed-mesh-berry'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mesh',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#BA00AD')
				},
				SpecularPBR: {
					color: _hexToRGB('#820070')
				},
				Opacity: {
	                 factor: 1
				}
			}
		}
	};

	customMaterials['dyed-mesh-black'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mesh',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#000000')
				},
				SpecularPBR: {
					color: _hexToRGB('#444444')
				}
			}
		}
	};

	customMaterials['dyed-mesh-coral'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mesh',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#FF5F3B')
				},
				SpecularPBR: {
					color: _hexToRGB('#777777')
				},
				Opacity: {
	                 factor: 1
				}
			}
		}
	};

	customMaterials['dyed-mesh-crystal'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mesh',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#95D9E3')
				},
				SpecularPBR: {
					color: _hexToRGB('#3E7287')
				},
				Opacity: {
	                 factor: 1
				},
				RoughnessPBR: {
	                 factor: 1
				}
			}
		}
	};

  	customMaterials['dyed-mesh-dark-royal'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mesh',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#102bc3')
				},
				SpecularPBR: {
					color: _hexToRGB('#020313')
				},
				Opacity: {
	                 factor: 1
				},
				RoughnessPBR: {
	                 factor: 1
				}
			}
		}
	};

	customMaterials['dyed-mesh-energize'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mesh',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#ea1887')
				},
				SpecularPBR: {
					color: _hexToRGB('#820883')
				},
				Opacity: {
	                 factor: 1
				}
			}
		}
	};

  	customMaterials['dyed-mesh-forest-green'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mesh',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#074533')
				},
				SpecularPBR: {
					color: _hexToRGB('#33443d')
				},
				Opacity: {
	                 factor: 1
				}
			}
		}
	};

   	customMaterials['dyed-mesh-graphite'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mesh',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#4d4d51')
				},
				SpecularPBR: {
					color: _hexToRGB('#444444')
				},
				Opacity: {
	                 factor: 1
				}
			}
		}
	};

	customMaterials['dyed-mesh-hot-pink'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mesh',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#FF009C')
				},
				SpecularPBR: {
					color: _hexToRGB('#FF8CD2')
				},
				Opacity: {
	                 factor: 1
				}
			}
		}
	};

	customMaterials['dyed-mesh-illusion'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mesh',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#694547')
				},
				SpecularPBR: {
					color: _hexToRGB('#694547')
				},
				Opacity: {
	                 factor: 1
				}
			}
		}
	};

	customMaterials['dyed-mesh-maroon'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mesh',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#600C17')
				},
				SpecularPBR: {
					color: _hexToRGB('#250912')
				},
				Opacity: {
	                 factor: 1
				}
			}
		}
	};

	customMaterials['dyed-mesh-navy'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mesh',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#000E44')
				},
				SpecularPBR: {
					color: _hexToRGB('#0D0D0D')
				}
			}
		}
	};

  	customMaterials['dyed-mesh-neon-coral'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mesh',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#FF0606')
				},
				SpecularPBR: {
					color: _hexToRGB('#F173B6')
				}
			}
		}
	};

  	customMaterials['dyed-mesh-new-sunshine'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mesh',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#f9ee00')
				},
				SpecularPBR: {
					color: _hexToRGB('#c46759')
				}
			}
		}
	};

  	customMaterials['dyed-mesh-lagoon'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mesh',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#054e55')
				},
				SpecularPBR: {
					color: _hexToRGB('#147f89 ')
				},
				Opacity: {
	                 factor: 1
				}
			}
		}
	};

	customMaterials['dyed-mesh-light-nude'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mesh',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#EAB187')
				},
				SpecularPBR: {
					color: _hexToRGB('#0C0C0C ')
				},
				Opacity: {
	                 factor: 1
				}
			}
		}
	};

	customMaterials['dyed-mesh-mid-nude'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mesh',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#C37A54')
				},
				SpecularPBR: {
					color: _hexToRGB('#0C0C0C ')
				},
				Opacity: {
	                 factor: 1
				}
			}
		}
	};

	customMaterials['dyed-mesh-deep-nude'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mesh',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#8D451F')
				},
				SpecularPBR: {
					color: _hexToRGB('#0C0C0C ')
				},
				Opacity: {
	                 factor: 1
				}
			}
		}
	};

	customMaterials['dyed-mesh-pony'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mesh',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#f3d1f7')
				},
				SpecularPBR: {
					color: _hexToRGB('#aca4af')
				}
			}
		}
	};

  	customMaterials['dyed-mesh-pink-sorbet'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mesh',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#f6a2c6')
				},
				SpecularPBR: {
					color: _hexToRGB('#daa7c6')
				}
			}
		}
	};

  	customMaterials['dyed-mesh-purple'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mesh',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#7D04C7')
				},
				SpecularPBR: {
					color: _hexToRGB('#55128E')
				}
			}
		}
	};

	customMaterials['dyed-mesh-raspberry'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mesh',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#CC0268')
				},
				SpecularPBR: {
					color: _hexToRGB('#702261')
				}
			}
		}
	};

	customMaterials['dyed-mesh-red'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mesh',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#E40000')
				},
				SpecularPBR: {
					color: _hexToRGB('#6F0000')
				}
			}
		}
	};

  	customMaterials['dyed-mesh-reflexion'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mesh',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#e870d3')
				},
				SpecularPBR: {
					color: _hexToRGB('#626262')
				}
			}
		}
	};

	customMaterials['dyed-mesh-royal'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mesh',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#003ACB')
				},
				SpecularPBR: {
					color: _hexToRGB('#3F3F3F')
				}
			}
		}
	};

  	customMaterials['dyed-mesh-shocking-pink'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mesh',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#ff009c')
				},
				SpecularPBR: {
					color: _hexToRGB('#ce6fa9')
				}
			}
		}
	};

	customMaterials['dyed-mesh-teal'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mesh',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#003C49')
				},
				SpecularPBR: {
					color: _hexToRGB('#003C49')
				}
			}
		}
	};

	customMaterials['dyed-mesh-titanium'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mesh',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#424248')
				},
				SpecularPBR: {
					color: _hexToRGB('#444444')
				}
			}
		}
	};

	customMaterials['dyed-mesh-white'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mesh',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#FFFFFF')
				},
				SpecularPBR: {
					color: _hexToRGB('#777777')
				},
				Opacity: {
	                 factor: 0.6
				}
			}
		}
	};

	customMaterials['dyed-mesh-wine'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-mesh',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#380024')
				},
				SpecularPBR: {
					color: _hexToRGB('#380024')
				}
			}
		}
	};
	
	//  Dyed Diamond Mesh
	
	customMaterials['dyed-diamond-mesh-black'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-diamond-mesh',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#000000')
				},
				SpecularPBR: {
					color: _hexToRGB('#444444')
				}
			}
		}
	};
	
	customMaterials['dyed-diamond-mesh-white'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-diamond-mesh',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#FFFFFF')
				},
				SpecularPBR: {
					color: _hexToRGB('#777777')
				},
				Opacity: {
	                 factor: 0.6
				}
			}
		}
	};

	//  Fog Mesh

	customMaterials['dyed-fog-mesh-baby-pink'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-fog-mesh',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#F1C1E7')
				},
				SpecularPBR: {
					color: _hexToRGB('#A77E9E')
				},
				Opacity: {
	                 factor: 0.8
				}
			}
		}
	};

	customMaterials['dyed-fog-mesh-black'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-fog-mesh',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#000000')
				},
				SpecularPBR: {
					color: _hexToRGB('#333333')
				}
			}
		}
	};

	customMaterials['dyed-fog-mesh-deep-sea'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-fog-mesh',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#000935')
				},
				SpecularPBR: {
					color: _hexToRGB('#41595D')
				}
			}
		}
	};

	customMaterials['dyed-fog-mesh-boysenberry'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-fog-mesh',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#B034A1')
				},
				SpecularPBR: {
					color: _hexToRGB('#A74D9C')
				},
				Opacity: {
	                 factor: 0.8
				}
			}
		}
	};

	customMaterials['dyed-fog-mesh-jade-black'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-fog-mesh',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#000000')
				},
				SpecularPBR: {
					color: _hexToRGB('#00343B')
				}
			}
		}
	};

	customMaterials['dyed-fog-mesh-jewel'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-fog-mesh',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#28BAC7')
				},
				SpecularPBR: {
					color: _hexToRGB('#1A6C6F')
				}
			}
		}
	};

	customMaterials['dyed-fog-mesh-lavender'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-fog-mesh',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#B6A8E1')
				},
				SpecularPBR: {
					color: _hexToRGB('#B6A8E1')
				},
				Opacity: {
	                 factor: 0.8
				}
			}
		}
	};

	customMaterials['dyed-fog-mesh-navy-black'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-fog-mesh',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#071838')
				},
				SpecularPBR: {
					color: _hexToRGB('#071838')
				}
			}
		}
	};

	customMaterials['dyed-fog-mesh-ocean'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-fog-mesh',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#00748E')
				},
				SpecularPBR: {
					color: _hexToRGB('#2C6068')
				}
			}
		}
	};

	customMaterials['dyed-fog-mesh-purple-black'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-fog-mesh',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#000000')
				},
				SpecularPBR: {
					color: _hexToRGB('#453279')
				}
			}
		}
	};

	customMaterials['dyed-fog-mesh-red-black'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-fog-mesh',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#000000')
				},
				SpecularPBR: {
					color: _hexToRGB('#793232')
				}
			}
		}
	};

	customMaterials['dyed-fog-mesh-rose-gold'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-fog-mesh',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#865B65')
				},
				SpecularPBR: {
					color: _hexToRGB('#865B65')
				},
				Opacity: {
	                 factor: 0.8
				}
			}
		}
	};

	customMaterials['dyed-fog-mesh-royal-black'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-fog-mesh',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#000000')
				},
				SpecularPBR: {
					color: _hexToRGB('#1557AF')
				}
			}
		}
	};

	customMaterials['dyed-fog-mesh-silver-black'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-fog-mesh',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#000000')
				},
				SpecularPBR: {
					color: _hexToRGB('#8D8D8D')
				}
			}
		}
	};

	customMaterials['dyed-fog-mesh-silver-white'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-fog-mesh',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#DED8D8')
				},
				SpecularPBR: {
					color: _hexToRGB('#B8A8A8')
				},
				Opacity: {
	                 factor: 0.8
				}
			}
		}
	};

	customMaterials['dyed-fog-mesh-spring-green'] = {
		pbrSpecification: {
			baseMaterial: 'dyed-fog-mesh',
			customisations: {
				DiffusePBR: {
					color: _hexToRGB('#3ACCD9')
				},
				SpecularPBR: {
					color: _hexToRGB('#A19E4B')
				},
				Opacity: {
	                 factor: 0.8
				}
			}
		}
	};

	// Crystals

	customMaterials['amethyst-crystal'] = {
		pbrSpecification: {
			baseMaterial: 'crystal',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#FFFFFF')
				},
				DiffusePBR: {
					color: _hexToRGB('#7F00A4')
				},
				RoughnessPBR: {
					factor: 0.3
				},
				Sheen: {
					colorFactor: _hexToRGB('#000000'),
					factor: 1
				}
			}
		}
	};

	customMaterials['aquamarine-ab-crystal'] = {
		pbrSpecification: {
			baseMaterial: 'crystal',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#FFFFFF')
				},
				DiffusePBR: {
					color: _hexToRGB('#00A3C8')
				},
				RoughnessPBR: {
					factor: 0.3
				},
				Sheen: {
					colorFactor: _hexToRGB('#FF967C'),
					factor: 1
				}
			}
		}
	};

	customMaterials['aquamarine-crystal'] = {
		pbrSpecification: {
			baseMaterial: 'crystal',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#FFFFFF')
				},
				DiffusePBR: {
					color: _hexToRGB('#00A3C8')
				},
				RoughnessPBR: {
					factor: 0.3
				},
				Sheen: {
					colorFactor: _hexToRGB('#A6A6A6'),
					factor: 1
				}
			}
		}
	};


	customMaterials['black-diamond-crystal'] = {
		pbrSpecification: {
			baseMaterial: 'crystal',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#FFFFFF')
				},
				DiffusePBR: {
					color: _hexToRGB('#2F2F2F')
				},
				RoughnessPBR: {
					factor: 0.677
				},
				Sheen: {
					colorFactor: _hexToRGB('#4E4E4E'),
	                 factor: 1
				}
			}
		}
	};

	customMaterials['blue-zircon-crystal'] = {
		pbrSpecification: {
			baseMaterial: 'crystal',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#FFFFFF')
				},
				DiffusePBR: {
					color: _hexToRGB('#00968E')
				},
				RoughnessPBR: {
					factor: 0.3
				},
				Sheen: {
					colorFactor: _hexToRGB('#18454E'),
	                 factor: 1
				}
			}
		}
	};

	customMaterials['blue-zircon-shimmer-crystal'] = {
		pbrSpecification: {
			baseMaterial: 'crystal',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#FFFFFF')
				},
				DiffusePBR: {
					color: _hexToRGB('#00968E')
				},
				RoughnessPBR: {
					factor: 0.093
				},
				Sheen: {
					colorFactor: _hexToRGB('#3C3C3C'),
					factor: 1
				}
			}
		}
	};

	customMaterials['capri-blue-crystal'] = {
		pbrSpecification: {
			baseMaterial: 'crystal',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#FFFFFF')
				},
				DiffusePBR: {
					color: _hexToRGB('#005E96')
				},
				RoughnessPBR: {
					factor: 0.561
				},
				Sheen: {
					colorFactor: _hexToRGB('#005E96'),
					factor: 1
				}
			}
		}
	};

	customMaterials['citrine-crystal'] = {
		pbrSpecification: {
			baseMaterial: 'crystal',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#FFED00')
				},
				DiffusePBR: {
					color: _hexToRGB('#FFED00')
				},
				RoughnessPBR: {
					factor: 0.3
				},
				Sheen: {
					colorFactor: _hexToRGB('#595959'),
					factor: 1
				}
			}
		}
	};

	customMaterials['sapphire-ab-crystal'] = {
		pbrSpecification: {
			baseMaterial: 'crystal',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#FFFFFF')
				},
				DiffusePBR: {
					color: _hexToRGB('#007696')
				},
				RoughnessPBR: {
					factor: 0.093
				},
				Sheen: {
					colorFactor: _hexToRGB('#3C3C3C'),
					factor: 1
				}
			}
		}
	};

	customMaterials['crystal-ab-crystal'] = {
		pbrSpecification: {
			baseMaterial: 'crystal',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#FFFFFF')
				},
				DiffusePBR: {
					color: _hexToRGB('#FF6F6F')
				},
				RoughnessPBR: {
					factor: 0.3
				},
				Sheen: {
					colorFactor: _hexToRGB('#FFFFFF'),
					factor: 1
				}
			}
		}
	};

	customMaterials['ab-crystal'] = {
		pbrSpecification: {
			baseMaterial: 'crystal',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#FFFFFF')
				},
				DiffusePBR: {
					color: _hexToRGB('#1299BE')
				},
				RoughnessPBR: {
					factor: 0.3
				},
				Sheen: {
					colorFactor: _hexToRGB('#FF967C'),
					factor: 1
				}
			}
		}
	};

	customMaterials['crystal-crystal'] = {
		pbrSpecification: {
			baseMaterial: 'crystal',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#FFFFFF')
				},
				DiffusePBR: {
					color: _hexToRGB('#FFFFFF')
				},
				RoughnessPBR: {
					factor: 0.3
				},
				Sheen: {
					colorFactor: _hexToRGB('#555555')
				}
			}
		}
	};

	customMaterials['clear-crystal'] = {
		pbrSpecification: {
			baseMaterial: 'crystal',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#FFFFFF')
				},
				DiffusePBR: {
					color: _hexToRGB('#FFFFFF')
				},
           
				Sheen: {
					colorFactor: _hexToRGB('#555555')
				}
			}
		}
	};

	customMaterials['crystal-rosaline-pearl-crystal'] = {
		pbrSpecification: {
			baseMaterial: 'crystal',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#FFDAED')
				},
				DiffusePBR: {
					color: _hexToRGB('#FFDAED')
				},
				RoughnessPBR: {
					factor: 1
				},
				Sheen: {
					colorFactor: _hexToRGB('#FFDAED'),
					factor: 1
				}
			}
		}
	};

	customMaterials['crystal-white-pearl-crystal'] = {
		pbrSpecification: {
			baseMaterial: 'crystal',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#FFF0F8')
				},
				DiffusePBR: {
					color: _hexToRGB('#FFF0F8')
				},
				RoughnessPBR: {
					factor: 1
				},
				Sheen: {
					colorFactor: _hexToRGB('#FFF0F8'),
					factor: 1
				}
			}
		}
	};

	customMaterials['electric-green-crystal'] = {
		pbrSpecification: {
			baseMaterial: 'crystal',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#0EE22B')
				},
				DiffusePBR: {
					color: _hexToRGB('#0EE22B')
				},
				RoughnessPBR: {
					factor: 1
				},
				Sheen: {
					colorFactor: _hexToRGB('#0EE22B'),
					factor: 1
				}
			}
		}
	};

	customMaterials['electric-orange-crystal'] = {
		pbrSpecification: {
			baseMaterial: 'crystal',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#FF4400')
				},
				DiffusePBR: {
					color: _hexToRGB('#FF4400')
				},
				RoughnessPBR: {
					factor: 1
				},
				Sheen: {
					colorFactor: _hexToRGB('#FF4400'),
					factor: 1
				}
			}
		}
	};

	customMaterials['electric-pink-crystal'] = {
		pbrSpecification: {
			baseMaterial: 'crystal',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#FF8CD2')
				},
				DiffusePBR: {
					color: _hexToRGB('#FF009C')
				},
				RoughnessPBR: {
					factor: 1
				},
				Sheen: {
					colorFactor: _hexToRGB('#FF8CD2'),
					factor: 1
				}
			}
		}
	};

	customMaterials['electric-violet-crystal'] = {
		pbrSpecification: {
			baseMaterial: 'crystal',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#A615FF')
				},
				DiffusePBR: {
					color: _hexToRGB('#A615FF')
				},
				RoughnessPBR: {
					factor: 1
				},
				Sheen: {
					colorFactor: _hexToRGB('#A615FF'),
					factor: 1
				}
			}
		}
	};

	customMaterials['electric-yellow-crystal'] = {
		pbrSpecification: {
			baseMaterial: 'crystal',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#DBFF00')
				},
				DiffusePBR: {
					color: _hexToRGB('#DBFF00')
				},
				RoughnessPBR: {
					factor: 1
				},
				Sheen: {
					colorFactor: _hexToRGB('#DBFF00'),
					factor: 1
				}
			}
		}
	};

  	customMaterials['emerald-green-crystal'] = {
		pbrSpecification: {
			baseMaterial: 'crystal',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#084815')
				},
				DiffusePBR: {
					color: _hexToRGB('#084815')
				},
				RoughnessPBR: {
					factor: 0.3
				},
				Sheen: {
					colorFactor: _hexToRGB('#084815'),
					factor: 1
				}
			}
		}
	};

	customMaterials['fuchsia-crystal'] = {
		pbrSpecification: {
			baseMaterial: 'crystal',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#E62988')
				},
				DiffusePBR: {
					color: _hexToRGB('#E62988')
				},
				RoughnessPBR: {
					factor: 1
				},
				Sheen: {
					colorFactor: _hexToRGB('#161616'),
					factor: 1
				}
			}
		}
	};

	customMaterials['golden-shadow-crystal'] = {
		pbrSpecification: {
			baseMaterial: 'crystal',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#FFFFFF')
				},
				DiffusePBR: {
					color: _hexToRGB('#C79444')
				},
				RoughnessPBR: {
					factor: 0.8
				},
				Sheen: {
					colorFactor: _hexToRGB('#C79444'),
					factor: 1
				}
			}
		}
	};

	customMaterials['jet-crystal'] = {
		pbrSpecification: {
			baseMaterial: 'crystal',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#222222')
				},
				DiffusePBR: {
					color: _hexToRGB('#000000')
				},
				Sheen: {
					colorFactor: _hexToRGB('#000000')
				}
			}
		}
	};

	customMaterials['light-amethyst-crystal'] = {
		pbrSpecification: {
			baseMaterial: 'crystal',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#FF9FF6')
				},
				DiffusePBR: {
					color: _hexToRGB('#FF9FF6')
				},
				RoughnessPBR: {
					factor: 0.3
				},
				Sheen: {
					colorFactor: _hexToRGB('#747474'),
					factor: 1
				}
			}
		}
	};

	customMaterials['light-siam-crystal'] = {
		pbrSpecification: {
			baseMaterial: 'crystal',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#FF0000')
				},
				DiffusePBR: {
					color: _hexToRGB('#FF0000')
				},
				RoughnessPBR: {
					factor: 0.3
				},
				Sheen: {
					colorFactor: _hexToRGB('#000000'),
					factor: 1
				}
			}
		}
	};

	customMaterials['light-siam-shimmer-crystal'] = {
		pbrSpecification: {
			baseMaterial: 'crystal',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#FF0000')
				},
				DiffusePBR: {
					color: _hexToRGB('#FF0000')
				},
				RoughnessPBR: {
					factor: 0.093
				},
				Sheen: {
					colorFactor: _hexToRGB('#A43F51'),
					factor: 1
				}
			}
		}
	};

	customMaterials['light-silk-crystal'] = {
		pbrSpecification: {
			baseMaterial: 'crystal',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#DABB99')
				},
				DiffusePBR: {
					color: _hexToRGB('#F7DDC8')
				},
				RoughnessPBR: {
					factor: 0.8
				},
				Sheen: {
					colorFactor: _hexToRGB('#F7DDC8'),
					factor: 0.2
				}
			}
		}
	};

	customMaterials['light-turquoise-crystal'] = {
		pbrSpecification: {
			baseMaterial: 'crystal',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#FFFFFF')
				},
				DiffusePBR: {
					color: _hexToRGB('#00BCB2')
				},
				RoughnessPBR: {
					factor: 0.3
				},
				Sheen: {
					colorFactor: _hexToRGB('#A6A6A6'),
					factor: 1
				}
			}
		}
	};

	customMaterials['metallic-blue-crystal'] = {
		pbrSpecification: {
			baseMaterial: 'crystal',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#FFFFFF')
				},
				DiffusePBR: {
					color: _hexToRGB('#003453')
				},
				RoughnessPBR: {
					factor: 0.3
				},
				Sheen: {
					colorFactor: _hexToRGB('#1C3955'),
					factor: 1
				}
			}
		}
	};

	customMaterials['padaparadscha-crystal'] = {
		pbrSpecification: {
			baseMaterial: 'crystal',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#FF7580')
				},
				DiffusePBR: {
					color: _hexToRGB('#FF7580')
				},
				RoughnessPBR: {
					factor: 0.3
				},
				Sheen: {
					colorFactor: _hexToRGB('#414141'),
					factor: 1
				}
			}
		}
	};

	customMaterials['peridot-crystal'] = {
		pbrSpecification: {
			baseMaterial: 'crystal',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#FFFFFF')
				},
				DiffusePBR: {
					color: _hexToRGB('#46BE5B')
				},
				RoughnessPBR: {
					factor: 0.3
				},
				Sheen: {
					colorFactor: _hexToRGB('#3C3C3C'),
					factor: 1
				}
			}
		}
	};

	customMaterials['alexandrite-crystal'] = {
		pbrSpecification: {
			baseMaterial: 'crystal',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#D4C5FF')
				},
				DiffusePBR: {
					color: _hexToRGB('#D4C5FF')
				},
				RoughnessPBR: {
					factor: 0.3
				},
				Sheen: {
					colorFactor: _hexToRGB('#000000'),
					factor: 1
				}
			}
		}
	};

	customMaterials['purple-velvet'] = {
		pbrSpecification: {
			baseMaterial: 'crystal',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#5C0094')
				},
				DiffusePBR: {
					color: _hexToRGB('#5C0094')
				},
				RoughnessPBR: {
					factor: 0.3
				},
				Sheen: {
					colorFactor: _hexToRGB('#000000'),
					factor: 1
				}
			}
		}
	};

	customMaterials['deep-purple-crystal'] = {
		pbrSpecification: {
			baseMaterial: 'crystal',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#5C0094')
				},
				DiffusePBR: {
					color: _hexToRGB('#5C0094')
				},
				Sheen: {
					colorFactor: _hexToRGB('#000000')
				}
			}
		}
	};

	customMaterials['rose-crystal'] = {
		pbrSpecification: {
			baseMaterial: 'crystal',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#FF83C1')
				},
				DiffusePBR: {
					color: _hexToRGB('#FF83C1')
				},
				RoughnessPBR: {
					factor: 0.3
				},
				Sheen: {
					colorFactor: _hexToRGB('#2B2B2B'),
					factor: 1
				}
			}
		}
	};

	customMaterials['rose-gold-crystal'] = {
		pbrSpecification: {
			baseMaterial: 'crystal',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#FFFFFF')
				},
				DiffusePBR: {
					color: _hexToRGB('#AC6D0B')
				},
				RoughnessPBR: {
					factor: 0.482
				},
				Sheen: {
					colorFactor: _hexToRGB('#AC6D0B'),
					factor: 0
				}
			}
		}
	};

	customMaterials['sun-crystal'] = {
		pbrSpecification: {
			baseMaterial: 'crystal',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#FF7A00')
				},
				DiffusePBR: {
					color: _hexToRGB('#FF7A00')
				},
				RoughnessPBR: {
					 factor: 0.3
				},
				Sheen: {
					colorFactor: _hexToRGB('#FF7A00'),
	                 factor: 1
				}
			}
		}
	};

	customMaterials['transmission-crystal'] = {
		pbrSpecification: {
			baseMaterial: 'crystal',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#FFFFFF')
				},
				DiffusePBR: {
					color: _hexToRGB('#495307')
				},
				RoughnessPBR: {
					factor: 0.3
				},
				Sheen: {
					colorFactor: _hexToRGB('#DBA97B'),
	                 factor: 1
				}
			}
		}
	};
	
	customMaterials['vintage-rose-crystal'] = {
		pbrSpecification: {
			baseMaterial: 'crystal',
			customisations: {
				SpecularPBR: {
					color: _hexToRGB('#DA9999')
				},
				DiffusePBR: {
					color: _hexToRGB('#DA9999')
				},
				RoughnessPBR: {
					factor: 0.8
				},
				Sheen: {
					colorFactor: _hexToRGB('#DA9999'),
					factor: 1
				}
			}
		}
	};

	return customMaterials;

}

export {
	__GHDConfiguratorBaseMaterials,
	__GHDConfiguratorCustomMaterials,
	_hexToRGB,
	_srgbToLinear,
	_linearToSrgb
};

